import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { HUB_PATH } from '../config';
import BrandMark from './BrandMark';
import SiteFooter from './SiteFooter';
import './Login.css';

function Login() {
  const [isLogin, setIsLogin] = useState(true);
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, register } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = isLogin
      ? await login(username, password)
      : await register(username, email, password);

    setLoading(false);

    if (result.success) {
      navigate(HUB_PATH);
    } else {
      setError(result.error);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-brand">
          <BrandMark size="md" />
        </div>
        <h1 className="login-title">Слово Дня</h1>
        <p className="login-subtitle">
          Угадай слово из 9 букв. Новое слово каждый день! 🍻 🥂🍹
        </p>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <input
              type="text"
              placeholder={isLogin ? 'Имя или email' : 'Имя пользователя'}
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              minLength={3}
              autoComplete="username"
              className="field"
            />
          </div>

          {!isLogin && (
            <div className="form-group">
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
                className="field"
              />
            </div>
          )}

          <div className="form-group">
            <input
              type="password"
              placeholder="Пароль"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={4}
              autoComplete={isLogin ? 'current-password' : 'new-password'}
              className="field"
            />
          </div>

          {error && <div className="alert alert-error">{error}</div>}

          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Загрузка...' : isLogin ? 'Войти' : 'Зарегистрироваться'}
          </button>
        </form>

        {isLogin && (
          <div className="toggle-mode">
            <Link to="/forgot-password" className="toggle-button">
              Забыли пароль?
            </Link>
          </div>
        )}

        <div className="toggle-mode">
          <button
            type="button"
            onClick={() => {
              setIsLogin(!isLogin);
              setError('');
            }}
            className="toggle-button"
          >
            {isLogin
              ? 'Нет аккаунта? Зарегистрироваться'
              : 'Уже есть аккаунт? Войти'}
          </button>
        </div>

        <SiteFooter className="site-footer--auth" />
      </div>
    </div>
  );
}

export default Login;
